<template>
    <div class="overlay active" v-if="showBanner">
           <div class="intro ">
                <div class="content">
                   <div class="pt-2 pb-2">
                        <LocaleChanger/>
                    </div>

                    <div class="jumbotron shadow">
                      <div class="content">
                        <p>
                           {{ $t('privacy.introduction') }}
                        </p>
                        <p class="details overflow-auto">
                            {{ $t('privacy.details') }}
                        </p>
                        <div class="text-right">
                            <button class="btn btn-muted" role="button" @click="decline()">{{ $t('privacy.buttons.decline') }}</button>
                            <button class="btn btn-primary btn-raised" @click="accept()" role="button">{{ $t('privacy.buttons.accept') }}</button>
                        </div>
                      </div>
                </div>
           </div>
       </div>
   </div>
</template>

<script>
    import { bootstrap } from 'vue-gtag'
    import LocaleChanger from '../components/LocaleChanger';

    export default {
        name: "DataPrivacyBanner",
        components: {LocaleChanger},
        data: function () {
            return {
                showBanner: true
            }
        },
        mounted() {
            if(this.$store.state.gdpr.accepted) {
                this.accept();
            }
        },
        methods: {
            accept() {
                this.$store.commit('acceptGdpr')
                bootstrap().then(gtag => {
                    // enabled gtag (analytics)
                })

                this.showBanner = false
            },
            decline() {
                // nothing happens if user decline
                this.showBanner = false
            }
        }
    }
</script>

<style scoped lang="scss">

    @import "../assets/styles/variables";

    p.details {
        font-size: 0.8em;
        max-height: 170px;
    }

    .jumbotron {
        .content {
          background: rgba(255,255,255,0.7);
          padding: 1em;
        }

        padding: 0;
        margin: 0;
        margin-bottom: 1em;
        background-image: url('../assets/img/components/data-privacy-banner/background-data-privacy-cookies.jpg');
        background-size: cover;
    }

    .intro {
      margin: auto;
      height: 100%;
      width: 100%;
      max-width: 600px;
      padding: 1em;
      padding-top: 0;
      font-size: 0.9em;
    }

    .intro .content {
      width: 100%;
      display: block;
    }

    .overlay {
      position: fixed;
      overflow-y: scroll;
      opacity: 0;
      visibility: hidden;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.95);
      z-index: 100;
      -webkit-transform: scale(1.8);
      -moz-transform: scale(1.8);
      -o-transform: scale(1.8);
      transform: scale(1.8);
    }

    .overlay.active {
      opacity: 1;
      visibility: visible;
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
</style>
